import React from "react";
import UsefulLinksIcon from "./images/UsefulLinksIcon";

const WidgetOrientationAdjustmentBoxLarge = ({ handle }) => {
  return (
    <div className="WidgetOrientationAjustmentBoxBg" role="region" aria-label="useful links">
      <label htmlFor="UseFulLinks" className="useFulLinksLabel">
        <p className="OrientationCenter" role="region" aria-label="useful links">
          <UsefulLinksIcon />
          UseFul Links
        </p>

        <select
          onChange={handle}
          name="UseFulLinks"
          id="UseFulLinks"
          style={{ width: "170px", borderRadius: "20px", padding: "3px 20px" }}
        >
          <option style={{ fontSize: "15px" }} value="Select an Option" role="region" aria-label="select an option">Select an Option</option>

        </select>
      </label>
    </div>
  );
};

export default WidgetOrientationAdjustmentBoxLarge;
